define(["exports", "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose", "react", "styled-components", "react-intl-universal", "../../utils", "../../themes", "../../atoms/Typography", "./BulletsAndText"], function (_exports, _taggedTemplateLiteralLoose2, _react, _styledComponents, _reactIntlUniversal, _utils, _themes, _Typography, _BulletsAndText) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _taggedTemplateLiteralLoose2 = _interopRequireDefault(_taggedTemplateLiteralLoose2);
  _react = _interopRequireWildcard(_react);
  _styledComponents = _interopRequireDefault(_styledComponents);
  _reactIntlUniversal = _interopRequireDefault(_reactIntlUniversal);
  _BulletsAndText = _interopRequireDefault(_BulletsAndText);

  var _templateObject, _templateObject2, _templateObject3;

  var StyledLegend = _styledComponents.default.div.withConfig({
    displayName: "Languages__StyledLegend",
    componentId: "sc-68x0jt-0"
  })(["display:none;padding:0 0 16px;> p{color:", ";width:100px;}> div{display:inline-flex;flex:2;p{display:inline-flex;flex:1;justify-content:space-around;margin:0;}}", ""], function (_ref) {
    var theme = _ref.theme;
    return theme.colors.darkGray;
  }, _themes.device.desktop(_templateObject || (_templateObject = (0, _taggedTemplateLiteralLoose2.default)(["\n    display: flex;\n    flex: 2;\n    justify-content: space-around;\n    text-align: center;\n  "]))));

  var ItemIdioma = _styledComponents.default.div.withConfig({
    displayName: "Languages__ItemIdioma",
    componentId: "sc-68x0jt-1"
  })(["display:block;+ div{border-top:solid 1px ", ";padding:16px 0 0 0;}em{color:", ";display:block;font-size:1.3em;font-style:normal;@media print{margin-bottom:12px;}}p{text-align:center;}> div{display:flex;}", ""], function (_ref2) {
    var theme = _ref2.theme;
    return theme.colors.lightGray;
  }, function (_ref3) {
    var theme = _ref3.theme;
    return theme.colors.darkGray;
  }, _themes.device.desktop(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteralLoose2.default)(["\n    align-items: center;\n    display: flex;\n    justify-content: space-around;\n    margin-bottom: 16px;\n    text-align: center;\n    \n    p {\n      display: inline-flex;\n      margin: 0;\n      text-align: left;\n      width: 100px;\n    }\n\n    em {\n      display: none;\n    }\n  "]))));

  var ItemIdiomaBullets = _styledComponents.default.div.withConfig({
    displayName: "Languages__ItemIdiomaBullets",
    componentId: "sc-68x0jt-2"
  })(["display:flex;justify-content:space-between;", ""], _themes.device.desktop(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteralLoose2.default)(["\n    display: inline-flex;\n    flex: 2;\n  "]))));

  var Languages = function Languages(_ref4) {
    var i18n = _ref4.i18n,
        currentLocale = _ref4.currentLocale,
        languages = _ref4.languages;

    var _useState = (0, _react.useState)(false),
        i18nLoaded = _useState[0],
        setI18nLoaded = _useState[1];

    var levels = ['leitura', 'escrita', 'conversacao'];
    (0, _react.useEffect)(function () {
      (0, _utils.initIntl)(i18n, currentLocale).then(function () {
        return setI18nLoaded(true);
      });
    }, []);
    return i18nLoaded ? /*#__PURE__*/_react.default.createElement("div", {
      "data-testid": "languages"
    }, /*#__PURE__*/_react.default.createElement(StyledLegend, null, /*#__PURE__*/_react.default.createElement(_Typography.Small, null), /*#__PURE__*/_react.default.createElement("div", null, levels.map(function (level) {
      return /*#__PURE__*/_react.default.createElement(_Typography.Small, {
        key: (0, _utils.uniqueId)()
      }, _reactIntlUniversal.default.get("IDIOMA." + level));
    }))), languages.map(function (item) {
      return /*#__PURE__*/_react.default.createElement(ItemIdioma, {
        key: (0, _utils.uniqueId)()
      }, /*#__PURE__*/_react.default.createElement(_Typography.P, null, item.idioma), /*#__PURE__*/_react.default.createElement(ItemIdiomaBullets, null, levels.map(function (level) {
        return /*#__PURE__*/_react.default.createElement(_BulletsAndText.default, {
          key: (0, _utils.uniqueId)(),
          label: level,
          level: _reactIntlUniversal.default.get('IDIOMA.NIVEL', {
            results: item.nivel[level]
          }),
          value: item.nivel[level]
        });
      })));
    })) : null;
  };

  var _default = Languages;
  _exports.default = _default;
});